import { Toast } from "@douyinfe/semi-ui";
import { format } from "date-fns";
import { zhCN } from "date-fns/locale";
import {
  IconMoneyExchangeStroked,
  IconIdCard,
  IconCoinMoneyStroked,
} from "@douyinfe/semi-icons";

import { Tag } from "@douyinfe/semi-ui";
import { displayRepaymentPlanStatus,displayPaidMethod ,displayMortgageLoanStatus} from "./api/ApiClient";



export function formatDate(obj: any) {
  if (!obj || typeof obj == "string") {
    return obj;
  }
  return format(obj, "yyyy-MM-dd");
}

export function formatDateTime(obj: any) {
  if (!obj || typeof obj == "string") {
    return obj;
  }
  return format(obj, "yyyy-MM-dd HH:mm:ss");
}

export function splitStr(obj: any, splitVar: any, returnIndex:number) {
  if (!obj || typeof obj != "string") {
    return obj;
  }
  let arr = obj.split(splitVar);
  return arr.length>returnIndex?arr[returnIndex]:arr[arr.length];
}

export function bytesToKb(bytes: number): string {
  return Math.round((bytes / 1024) * 100) / 100 + "kb";
}

export function meetRoles(roles: string[], userRoles: string[]): boolean {
  if (!userRoles) {
    return false;
  }
  for (var i = 0; i < roles.length; i++) {
    if (userRoles.includes(roles[i])) {
      return true;
    }
  }
  return false;
}
export function filterObj(obj: any) {
  if (!obj) {
    return obj;
  }
  let result: any = {};
  Object.keys(obj).forEach((k) => {
    if (obj[k] !== null && obj[k] !== undefined && k !== 'navigateTo') {
      result[k] = obj[k];
    }
  });
  return result;
}

export function setObjValue(obj: any, keypath: string, value: any) {
  let paths = keypath.split(".");
  let i = 0;
  for (; i < paths.length - 1; i++) {
    if (obj[paths[i]] === undefined) {
      obj[paths[i]] = {};
    }
    obj = obj[paths[i]];
  }
  obj[paths[i]] = value;
}

export async function copy(a: string) {
  try {
    await navigator.clipboard.writeText(a);
    Toast.info("已复制");
  } catch (e) {
    Toast.info("复制错误 " + e);
  }
}

export function formatDatetimeStr(datetime: string) {
  if (datetime) {
    return datetime.replace("T", " ").replace(/\..*/, "");
  } else {
    return "";
  }
}

export function formatNumber(number: number) {
  if (number === null || number === undefined) {
    return "0";
  } else {
    return number + "";
  }
}

export function formatAmount(amount: any): string {
  if (amount === null || amount === undefined) {
    return "0";
  } else {
    return amount / 100 + "";
  }
}

export function formatAmountZhCn(amount: any): string {
  if (amount === null || amount === undefined) {
    return "0";
  } else {
    return amount.toLocaleString("zh-CN", {
      style: "currency",
      currency: "CNY",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
}

export function formatAmountZhCnZero1(amount: any): string {
  if (amount === null || amount === undefined) {
    return "0.0";
  } else {
    return amount.toLocaleString("zh-CN", {
      style: "currency",
      currency: "CNY",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
  }
}

export function formatPercent(amount: any, withSign?: boolean): string {
  return formatFloat(amount * 100) + "%";
}

export function avatarName(name: string) {
  if (!name) {
    return "无名";
  }
  if (name.length > 3) {
    return name.substring(0, 3);
  }
  return name;
}

export function displayStar(star: number) {
  if (star < 0 || star === undefined || star === null) {
    return "";
  }
  return star + "星";
}

import { formatDistance, formatRelative, parseISO } from "date-fns";
import sprintf from "@jitesoft/sprintf";
import Section from "@douyinfe/semi-ui/lib/cjs/form/section";

export function formatDuration(s: number) {
  if (s === null || s === undefined) {
    return s;
  }
  return formatDistance(0, s * 1000, { includeSeconds: false, locale: zhCN });
}

export function formatRelativeTime(s: string) {
  // if (!s) {
  //   return s;
  // }
  // return formatRelative(parseISO(s), new Date(), { locale: zhCN });
  return s;
}

export const StarList = [0, 1, 2, 3, 4, 5];

export function maskMobile(mobile: string | undefined): string | undefined {
  if (!mobile) {
    return mobile;
  }
  return mobile.slice(0, 3) + "****" + mobile.slice(7, 11);
}

export function beep() {
  const audio = new Audio("/mis/beep.mp3");
  audio.play();
}

export function formatFloat(x: any) {
  const format = "%.2f";
  if (x === undefined || x === null) {
    x = 0;
  }
  return sprintf(format, x);
}

export function hasValidChildren(obj: any): boolean {
  return (
      obj?.children !== undefined &&
      obj?.children !== null &&
      Array.isArray(obj.children) &&
      obj.children.length > 0
  );
}

export function  renderLoanStatusTag (value: any, record: any ) {
        if (record.loanStatus == "BAD_DEPT") {
          return (
            <Tag
              color="pink"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              已坏账
            </Tag>
          );
        } else if (record.loanStatus == "SETTLED") {
          return (
            <Tag
              color="grey"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              已释放
            </Tag>
          );
        } else if (value == "YQ") {
          return (
            <Tag
              color="red"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              已逾期
            </Tag>
          );
        } else if (value == "YJQ") {
          return (
            <Tag
              color="green"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              已结清
            </Tag>
          );
        } else if (value == "HKZ") {
          return (
            <Tag
              color="blue"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              还款中
            </Tag>
          );
        } else if(value) {
          return (
            <Tag key={value} size="large" shape="circle" type="solid">
              {value}
            </Tag>
          );
        }
}

  export function  renderStatDetailContent (statDataObj)  {
    const d = statDataObj || {};
    const safe = (v: any) => v || 0;
    const fmt = (v: any) => formatAmountZhCn(v || 0);
    const mTotal = safe(d.totalLoanAmount);
    const mHelp = safe(d.totalHelpPaidAmount);
    const mSelf = safe(d.totalPaidAmount) - mHelp;
    const cTotal = safe(d.totalCardAmount);
    const cHelpRepay = safe(d.totalCardHelpPaidAmount);
    const cSelfRepay = safe(d.totalCardPaidAmount) - cHelpRepay;
    const cHelpPost = safe(d.totalHelpPostingAmount);
    const cSelfPost = safe(d.totalPostingAmount) - cHelpPost;
    const bTotal = safe(d.totalBorrowAmount);
    const bReturn = safe(d.totalReturnAmount);
    const bRemain = bTotal - bReturn;

    const allHelp = mHelp + cHelpRepay + cHelpPost;
    const allSelf = mSelf + cSelfRepay + bReturn ;
    const totalAmount = mTotal + cTotal + bTotal;
    const outAmount = mHelp + cHelpRepay + cHelpPost + bTotal;
    const expenseAmount = mHelp + cHelpRepay + cHelpPost + bRemain;

    const colStyle: React.CSSProperties = { flex: '1 1 0', minWidth: 130, padding: '8px 12px', borderRadius: 6, background: 'var(--semi-color-bg-1)' };
    const itemStyle: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', padding: '2px 0', fontSize: 13 };
    const lbl = (color: string): React.CSSProperties => ({ color, fontWeight: 500 });

    return (
      <div style={{ width: 760, padding: '4px 0' }}>
        <div style={{ display: 'flex', gap: 10 }}>
          <div style={{ ...colStyle, borderLeft: '3px solid #1677ff' }}>
            <div style={{ fontWeight: 'bold', color: '#1677ff', marginBottom: 4, fontSize: 16 }}><IconMoneyExchangeStroked style={{marginRight: 4}}/>贷款</div>
            <div style={itemStyle}><span style={lbl('#1677ff')}>金额</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(mTotal)}</span></div>
            <div style={itemStyle}><span style={lbl('#52c41a')}>代还</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(mHelp)}</span></div>
            <div style={itemStyle}><span style={lbl('#30332e')}>自还</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(mSelf)}</span></div>
          </div>
          <div style={{ ...colStyle, borderLeft: '3px solid #722ed1' }}>
            <div style={{ fontWeight: 'bold', color: '#722ed1', marginBottom: 4, fontSize: 16 }}><IconIdCard style={{marginRight: 4}}/>信用卡</div>
            <div style={itemStyle}><span style={lbl('#1677ff')}>金额</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cTotal)}</span></div>
            <div style={itemStyle}><span style={lbl('#52c41a')}>代还还款</span ><span  style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cHelpRepay)}</span></div>
            <div style={itemStyle}><span style={lbl('#30332e')}>自还还款</span><span  style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cSelfRepay)}</span></div>
            <div style={itemStyle}><span style={lbl('#722ed1')}>代还过账</span><span  style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cHelpPost)}</span></div>
            <div style={itemStyle}><span style={lbl('#30332e')}>自还过账</span><span  style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cSelfPost)}</span></div>
          </div>

          <div style={{ ...colStyle, borderLeft: '3px solid #fa8c16' }}>
            <div style={{ fontWeight: 'bold', color: '#fa8c16', marginBottom: 4, fontSize: 16 }}><IconCoinMoneyStroked style={{marginRight: 4}}/>借款</div>
            <div style={itemStyle}><span style={lbl('#52c41a')}>金额</span><span  style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(bTotal)}</span></div>
            <div style={itemStyle}><span style={lbl('#30332e')}>自还</span><span  style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(bReturn)}</span></div>
            <div style={itemStyle}><span style={lbl('#e91e63')}>待还</span><span  style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(bRemain)}</span></div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
          {[
            { label: '总贷款金额', formula: '贷款+信用卡+借款', value: totalAmount, color: '#1677ff', border: '#1677ff' },
            { label: '总代还金额', formula: '贷款代还+信用卡代还还款+信用卡代还过账', value: allHelp, color: '#52c41a', border: '#52c41a' },
            { label: '总自还金额', formula: '贷款自还+信用卡自还还款+信用卡自还过账+借款已还', value: allSelf, color: '#30332e', border: '#30332e' },
            
          ].map(s => (
            <div key={s.label} style={{ flex: '1 1 0', textAlign: 'center', padding: '6px 8px',
              borderRadius: 6, background: 'var(--semi-color-bg-1)', borderLeft: `3px solid ${s.border}` }}>
              <div style={{ fontSize: 11, color: s.color, fontWeight: 500 }}>{s.label}</div>
              <div style={{ fontSize: 10, color: 'var(--semi-color-text-2)', lineHeight: 1.3 }}>{s.formula}</div>
              <div style={{ fontWeight: 'bold', color: s.color, fontSize: 15 }}>{fmt(s.value)}</div>
            </div>
          ))}
        </div>
        
        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
          {[
            { label: '出款金额', formula: '贷款代还+信用卡代还还款+借款金额', value: outAmount, color: '#52c41a', border: '#52c41a' },
            { label: '支出金额', formula: '贷款代还+信用卡代还还款+借款金额-借款已还', value: expenseAmount, color: '#e91e63', border: '#e91e63' },
            { label: '', formula: '', value: null, color: '#ffffff', border: '#ffffff' },

          ].map(s => (
            <div key={s.label} style={{ flex: '1 1 0', minWidth: 140, textAlign: 'center', padding: '6px 8px',
              borderRadius: 6, background: 'var(--semi-color-bg-1)', borderLeft: `3px solid ${s.border}` }}>
              <div style={{ fontSize: 11, color: s.color, fontWeight: 500 }}>{s.label}</div>
              <div style={{ fontSize: 10, color: 'var(--semi-color-text-2)', lineHeight: 1.3 }}>{s.formula}</div>
              <div style={{ fontWeight: 'bold', color: s.color, fontSize: 15 }}>{fmt(s.value)||''}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

    // 统计详情 Popover 内容（三个Tab共用）
    export function renderStatDetailContentPlan (dataObj: any)  {
      const d = dataObj || {};
      const safe = (v: any) => v || 0;
      const fmt = (v: any) => formatAmountZhCn(v || 0);
      const mTotal = safe(d.loanAmount);
      const mHelp = safe(d.loanHelpRepaymentPlanAmount);
      const mSelf = safe(d.loanRepaymentPlanAmount) - mHelp;
      const cTotal = safe(d.cardAmount);
      const cHelpRepay = safe(d.cardHelpRepaymentPlanAmount);
      const cSelfRepay = safe(d.cardRepaymentPlanAmount) - cHelpRepay;
      const cHelpPost = safe(d.cardHelpPostingPlanAmount);
      const cSelfPost = safe(d.cardPostingPlanAmount) - cHelpPost;
      const bTotal = safe(d.borrowAmount);
      const bReturn = safe(d.borrowReturnAmount);
      const bRemain = bTotal - bReturn;
  
      const allHelp = mHelp + cHelpRepay + cHelpPost;
      const allSelf = mSelf + cSelfRepay + bReturn ;
      const totalAmount = mTotal + cTotal + bTotal;
      const outAmount = mHelp + cHelpRepay  + bTotal;
      const expenseAmount = mHelp + cHelpRepay + cHelpPost + bRemain;
  
      const colStyle: React.CSSProperties = { flex: '1 1 0', minWidth: 130, padding: '8px 12px', borderRadius: 6, background: 'var(--semi-color-bg-1)' };
      const itemStyle: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', padding: '2px 0', fontSize: 13 };
      const lbl = (color: string): React.CSSProperties => ({ color, fontWeight: 500 });
  
      return (
        <div style={{ width: 960, padding: '4px 0' }}>
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ ...colStyle, borderLeft: '3px solid #1677ff' }}>
              <div style={{ fontWeight: 'bold', color: '#1677ff', marginBottom: 4, fontSize: 16 }}><IconMoneyExchangeStroked style={{marginRight: 4}}/>贷款</div>
              <div style={itemStyle}><span style={lbl('#1677ff')}>金额</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(mTotal)}</span></div>
              <div style={itemStyle}><span style={lbl('#52c41a')}>代还</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(mHelp)}</span></div>
              <div style={itemStyle}><span style={lbl('#30332e')}>自还</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(mSelf)}</span></div>
            </div>
            <div style={{ ...colStyle, borderLeft: '3px solid #722ed1' }}>
              <div style={{ fontWeight: 'bold', color: '#722ed1', marginBottom: 4, fontSize: 16 }}><IconIdCard style={{marginRight: 4}}/>信用卡</div>
              <div style={itemStyle}><span style={lbl('#1677ff')}>金额</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cTotal)}</span></div>
              <div style={itemStyle}><span style={lbl('#52c41a')}>代还还款</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cHelpRepay)}</span></div>
              <div style={itemStyle}><span style={lbl('#30332e')}>自还还款</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cSelfRepay)}</span></div>
              <div style={itemStyle}><span style={lbl('#722ed1')}>代还过账</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cHelpPost)}</span></div>
              <div style={itemStyle}><span style={lbl('#30332e')}>自还过账</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(cSelfPost)}</span></div>
            </div>
            <div style={{ ...colStyle, borderLeft: '3px solid #fa8c16' }}>
              <div style={{ fontWeight: 'bold', color: '#fa8c16', marginBottom: 4, fontSize: 16 }}><IconCoinMoneyStroked style={{marginRight: 4}}/>借款</div>
              <div style={itemStyle}><span style={lbl('#52c41a')}>金额</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(bTotal)}</span></div>
              <div style={itemStyle}><span style={lbl('#30332e')}>自还</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(bReturn)}</span></div>
              <div style={itemStyle}><span style={lbl('#e91e63')}>待还</span><span style={{ fontWeight: 'bold', fontSize: 15 }}>{fmt(bRemain)}</span></div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
            {[
               { label: '总贷款金额', formula: '贷款+信用卡+借款', value: totalAmount, color: '#1677ff', border: '#1677ff' },
               { label: '总代还金额', formula: '贷款代还+信用卡代还还款+信用卡代还过账', value: allHelp, color: '#52c41a', border: '#52c41a' },
               { label: '总自还金额', formula: '贷款自还+信用卡自还还款+信用卡自还过账+借款已还', value: allSelf, color: '#30332e', border: '#30332e' },
            ].map(s => (
              <div key={s.label} style={{ flex: '1 1 0', textAlign: 'center', padding: '6px 8px',
                borderRadius: 6, background: 'var(--semi-color-bg-1)', borderLeft: `3px solid ${s.border}` }}>
                <div style={{ fontSize: 11, color: s.color, fontWeight: 500 }}>{s.label}</div>
                <div style={{ fontSize: 10, color: 'var(--semi-color-text-2)', lineHeight: 1.3 }}>{s.formula}</div>
                <div style={{ fontWeight: 'bold', color: s.color, fontSize: 15 }}>{fmt(s.value)}</div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
            {[
               { label: '出款金额', formula: '贷款代还+信用卡代还还款+借款金额', value: outAmount, color: '#52c41a', border: '#52c41a' },
               { label: '支出金额', formula: '贷款代还+信用卡代还还款+借款金额-借款已还', value: expenseAmount, color: '#e91e63', border: '#e91e63' },
               { label: '', formula: '', value: null, color: '#ffffff', border: '#ffffff' },
            ].map(s => (
              <div key={s.label} style={{ flex: '1 1 0', minWidth: 140, textAlign: 'center', padding: '6px 8px',
                borderRadius: 6, background: 'var(--semi-color-bg-1)', borderLeft: `3px solid ${s.border}` }}>
                <div style={{ fontSize: 11, color: s.color, fontWeight: 500 }}>{s.label}</div>
                <div style={{ fontSize: 10, color: 'var(--semi-color-text-2)', lineHeight: 1.3 }}>{s.formula}</div>
                <div style={{ fontWeight: 'bold', color: s.color, fontSize: 15 }}>{fmt(s.value)}</div>
              </div>
            ))}
          </div>
        </div>
      );
    }
export function renderRepaymentPlanStatusTag(value: any, record: any) {
  if (record.loanStatus == "BAD_DEPT") {
    return (<Tag color="pink" key={value} size="large" shape="circle" type="solid"> 已坏账 </Tag>);
  } else if (record.loanStatus == "SETTLED") {
    return (<Tag color="grey" key={value} size="large" shape="circle" type="solid"> 已释放 </Tag>);
  } else if (record.paidMethod && record.paidMethod.includes("_GZ_")) {
    return (<Tag color="teal" key={value} size="large" shape="circle" type="solid"> 已过账 </Tag>);
  } else if (record.paidMethod && record.paidMethod.includes("_JQ_")) {
    return (<Tag color="violet" key={value} size="large" shape="circle" type="solid"> 已结清 </Tag>);
  } else if (value == "YQ") {
    return (<Tag color="red" key={value} size="large" shape="circle" type="solid"> {displayRepaymentPlanStatus(value)} </Tag>);
  } else if (value == "YJQ") {
    return (<Tag color="green" key={value} size="large" shape="circle" type="solid"> {displayRepaymentPlanStatus(value)} </Tag>);
  } else if(value) {
    return (<Tag color="blue" key={value} size="large" shape="circle" type="solid"> {displayRepaymentPlanStatus(value)} </Tag>);
  }
}

export function renderPeriodNo (value, record:any)  {
  if(!value){
      return '';
  }
  else      if (record.createdBy && record.createdBy > 0) {
          return (
            <Tag color={"blue"} key={value} size="large" shape="circle" type="solid">
              {" "}{value}期/{record.maxPeriodNo}期{" "}
            </Tag>
          );
        } else if (record.paidUserId == -99) {
          // paidUserId=-99 表示客户自还
          return (
            <Tag color={"orange"} key={value} size="large" shape="circle" type="solid">
              {" "}{value}期/{record.maxPeriodNo}期{" "}
            </Tag>
          );
        } else {
          return value + "期/"+record.maxPeriodNo+"期";
        }
  }

const _tooltipCardBg = 'var(--semi-color-bg-1)';
const _tooltipRowStyle: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', padding: '2px 0', fontSize: 13 };
const _tooltipLbl = (c: string): React.CSSProperties => ({ color: c, fontWeight: 500 });
const _tooltipVal: React.CSSProperties = { fontWeight: 'bold', color: 'var(--semi-color-text-0)' };

export function renderRepaymentCountTooltip(record: any) {
  const safe = (v: any) => v || 0;
  const loanHelp = safe(record.loanHelpRepaymentCount);
  const loanSelf = safe(record.loanRepaymentCount) - loanHelp;
  const cardHelpRepay = safe(record.cardHelpRepaymentCount);
  const cardSelfRepay = safe(record.cardRepaymentCount) - cardHelpRepay;
  const cardHelpPost = safe(record.cardHelpPostingCount);
  const cardSelfPost = safe(record.cardPostingCount) - cardHelpPost;
  const borrowPaid = safe(record.borrowPaidPlanCount);
  const card: React.CSSProperties = { flex: '1 1 0', padding: '8px 12px', borderRadius: 6, background: _tooltipCardBg };
  return (
    <div style={{ width: 420, padding: '4px 0' }}>
      <div style={{ display: 'flex', gap: 10 }}>
        <div style={{ ...card, borderLeft: '3px solid #1677ff' }}>
          <div style={{ fontWeight: 'bold', color: '#1677ff', marginBottom: 4, fontSize: 14 }}>贷款还款笔数</div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#52c41a')}>代还</span><span style={_tooltipVal}>{loanHelp}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>自还</span><span style={_tooltipVal}>{loanSelf}</span></div>
        </div>
        <div style={{ ...card, borderLeft: '3px solid #722ed1' }}>
          <div style={{ fontWeight: 'bold', color: '#722ed1', marginBottom: 4, fontSize: 14 }}>信用卡还款笔数</div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#52c41a')}>代还还款</span><span style={_tooltipVal}>{cardHelpRepay}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>自还还款</span><span style={_tooltipVal}>{cardSelfRepay}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#722ed1')}>代还过账</span><span style={_tooltipVal}>{cardHelpPost}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>自还过账</span><span style={_tooltipVal}>{cardSelfPost}</span></div>
        </div>
        <div style={{ ...card, borderLeft: '3px solid #fa8c16' }}>
          <div style={{ fontWeight: 'bold', color: '#fa8c16', marginBottom: 4, fontSize: 14 }}>借款还款笔数</div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>已还</span><span style={_tooltipVal}>{borrowPaid}</span></div>
        </div>
      </div>
    </div>
  );
}

export function renderOutMoneyAmountTooltip(record: any) {
  const safe = (v: any) => v || 0;
  const fmt = (v: any) => formatAmountZhCn(v || 0);
  const mHelp = safe(record.totalHelpPaidAmount);
  const mSelf = safe(record.totalPaidAmount) - mHelp;
  const cHelpRepay = safe(record.totalCardHelpPaidAmount);
  const cSelfRepay = safe(record.totalCardPaidAmount) - cHelpRepay;
  const cHelpPost = safe(record.totalHelpPostingAmount);
  const cSelfPost = safe(record.totalPostingAmount) - cHelpPost;
  const bTotal = safe(record.totalBorrowAmount);
  const bReturn = safe(record.totalReturnAmount);
  const bRemain = bTotal - bReturn;
  const expense = mHelp + cHelpRepay + cHelpPost + bRemain;
  const card: React.CSSProperties = { flex: '1 1 0', padding: '8px 12px', borderRadius: 6, background: _tooltipCardBg };
  return (
    <div style={{ width: 450, padding: '4px 0' }}>
      <div style={{ display: 'flex', gap: 10 }}>
        <div style={{ ...card, borderLeft: '3px solid #1677ff' }}>
          <div style={{ fontWeight: 'bold', color: '#1677ff', marginBottom: 4, fontSize: 14 }}>贷款还款金额</div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#52c41a')}>代还</span><span style={_tooltipVal}>{fmt(mHelp)}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>自还</span><span style={_tooltipVal}>{fmt(mSelf)}</span></div>
        </div>
        <div style={{ ...card, borderLeft: '3px solid #722ed1' }}>
          <div style={{ fontWeight: 'bold', color: '#722ed1', marginBottom: 4, fontSize: 14 }}>信用卡还款金额</div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#52c41a')}>代还还款</span><span style={_tooltipVal}>{fmt(cHelpRepay)}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>自还还款</span><span style={_tooltipVal}>{fmt(cSelfRepay)}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#722ed1')}>代还过账</span><span style={_tooltipVal}>{fmt(cHelpPost)}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>自还过账</span><span style={_tooltipVal}>{fmt(cSelfPost)}</span></div>
        </div>
        <div style={{ ...card, borderLeft: '3px solid #fa8c16' }}>
          <div style={{ fontWeight: 'bold', color: '#fa8c16', marginBottom: 4, fontSize: 14 }}>借款还款金额</div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#52c41a')}>金额</span><span style={_tooltipVal}>{fmt(bTotal)}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#30332e')}>已还</span><span style={_tooltipVal}>{fmt(bReturn)}</span></div>
          <div style={_tooltipRowStyle}><span style={_tooltipLbl('#e91e63')}>待还</span><span style={_tooltipVal}>{fmt(bRemain)}</span></div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
        {[
          { label: '出款金额', formula: '代还+代还还款+代还过账+借款未还', value: expense, color: '#52c41a', border: '#52c41a' },
          { label: '支出金额', formula: '代还+代还还款+代还过账+借款金额-借款已还', value: expense, color: '#e91e63', border: '#e91e63' },
        ].map(item => (
          <div key={item.label} style={{ flex: '1 1 0', textAlign: 'center', padding: '6px 8px',
            borderRadius: 6, background: _tooltipCardBg, borderLeft: `3px solid ${item.border}` }}>
            <div style={{ fontSize: 11, color: item.color, fontWeight: 500 }}>{item.label}</div>
            <div style={{ fontSize: 10, color: 'var(--semi-color-text-2)', lineHeight: 1.3 }}>{item.formula}</div>
            <div style={{ fontWeight: 'bold', color: item.color, fontSize: 15 }}>{fmt(item.value)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function renderLoanCountTooltip(record: any) {
  const safe = (v: any) => v || 0;
  const fmt = (v: any) => formatAmountZhCn(v || 0);
  const row: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '3px 0', fontSize: 13 };
  const rows = [
   
    { label: '贷款数', count: safe(record.loanCount), amount: fmt(record.totalLoanAmount), color: '#1677ff', border: '#1677ff' },
    { label: '信用卡数', count: safe(record.cardCount), amount: fmt(record.totalCardAmount), color: '#722ed1', border: '#722ed1' },
    { label: '借款数', count: safe(record.borrowCount), amount: fmt(record.totalBorrowAmount), color: '#fa8c16', border: '#fa8c16' },
  ];
  return (
    <div style={{ width: 230, padding: '4px 0' }}>
      {rows.map(r => (
        <div key={r.label} style={{ ...row, borderLeft: `3px solid ${r.border}`, paddingLeft: 8, borderRadius: 2, background: _tooltipCardBg, marginBottom: 4 }}>
          <span style={{ color: r.color, fontWeight: 600, width: 60 }}>{r.label}</span>
          <span style={{ color: r.color, fontWeight: 'bold', width: 30, textAlign: 'center' }}>{r.count}</span>
          {r.amount !== undefined && <span style={{ color: r.color, fontWeight: 'bold', flex: 1, textAlign: 'right' }}>{r.amount}</span>}
        </div>
      ))}
    </div>
  );
}

export function renderRepaymentProgressTooltip(record: any) {
  const safe = (v: any) => v || 0;
  const pct = (done: number, total: number) => total > 0 ? Math.round(done / total * 100) : 0;
  const barBg: React.CSSProperties = { width: '100%', height: 8, borderRadius: 4, background: 'var(--semi-color-fill-1)', marginTop: 4 };
  const rows = [
    { label: '总进度', done: safe(record.repaymentCount), total: safe(record.repaymentPlanCount), color: '#52c41a' },
    { label: '贷款进度', done: safe(record.loanRepaymentCount), total: safe(record.loanPlanCount), color: '#1677ff' },
    { label: '信用卡进度', done: safe(record.cardRepaymentCount), total: safe(record.cardPlanCount), color: '#722ed1' },
    { label: '借款进度', done: safe(record.borrowPaidCount), total: safe(record.borrowPlanCount), color: '#fa8c16' },
  ];
  return (
    <div style={{ width: 340, padding: '4px 0' }}>
      {rows.map(r => {
        const p = pct(r.done, r.total);
        return (
          <div key={r.label} style={{ marginBottom: 8, padding: '6px 10px', borderRadius: 6, background: _tooltipCardBg, borderLeft: `3px solid ${r.color}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
              <span style={{ color: r.color, fontWeight: 600 }}>{r.label}</span>
              <span style={{ color: 'var(--semi-color-text-0)', fontWeight: 500 }}>{r.done}/{r.total} <span style={{ color: r.color, marginLeft: 4 }}>{p}%</span></span>
            </div>
            <div style={barBg}>
              <div style={{ width: `${p}%`, height: '100%', borderRadius: 4, background: r.color, transition: 'width 0.3s' }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function renderPaidMethodTag(value: any) {
  if (!value) return null;
  if (value.includes("_ZH")) {
    return (<Tag color="grey" key={value} size="large" shape="circle" type="solid"> {displayPaidMethod(value)} </Tag>);
  } 
  else if (value.includes("JQ")) {
    return (<Tag color="violet" key={value} size="large" shape="circle" type="solid"> {displayPaidMethod(value)} </Tag>);
  }
  else if (value.includes("GZ")) {
    return (<Tag color="teal" key={value} size="large" shape="circle" type="solid"> {displayPaidMethod(value)} </Tag>);
  } else if (value.includes("_DH")) {
    return (<Tag color="green" key={value} size="large" shape="circle" type="solid"> {displayPaidMethod(value)} </Tag>);
  } else if (value == "DH") {
    return (<Tag color="blue" key={value} size="large" shape="circle" type="solid"> {displayPaidMethod(value)} </Tag>);
  }else if (value== "KHZH") {
    return (<Tag color="grey" key={value} size="large" shape="circle" type="solid"> {displayPaidMethod(value)} </Tag>);
  }
  return (<Tag key={value} size="large" shape="circle" type="solid"> {displayPaidMethod(value)} </Tag>);
}

export function renderReviewStatusTag(value: any) {
  if (!value) {
    return (<Tag color="white" key={value} size="large" shape="circle" type="solid"> 无 </Tag>);
  }
  else if (value === "PENDING") {
    return (<Tag color="orange" key={value} size="large" shape="circle" type="solid"> 待审核 </Tag>);
  } else if (value === "REJECTED") {
    return (<Tag color="red" key={value} size="large" shape="circle" type="solid"> 已驳回 </Tag>);
  } else if (value === "YJQ") {
    return (<Tag color="green" key={value} size="large" shape="circle" type="solid"> 已确认 </Tag>);
  } else if (value === "CANCEL") {
    return (<Tag color="cyan" key={value} size="large" shape="circle" type="solid"> 取消中 </Tag>);
  } else if (value === "EDIT") {
    return (<Tag color="purple" key={value} size="large" shape="circle" type="solid"> 编辑中 </Tag>);
  } else if (value === "HKZ") {
    return (<Tag color="blue" key={value} size="large" shape="circle" type="solid"> 还款中 </Tag>);
  } else if (value === "YQ") {
    return (<Tag color="red" key={value} size="large" shape="circle" type="solid"> 已逾期 </Tag>);
  }
  return null;
}

const statusLabel: Record<string, string> = {
  HKZ: "还款中", YJQ: "已确认", YQ: "已逾期", PENDING: "待审核",
  REJECTED: "已驳回", EDIT: "编辑中", CANCEL: "取消中",
};

export function renderStatusTransition(prev: any, next: any) {
  const p = prev ? (statusLabel[prev] || prev) : "-";
  const n = next ? (statusLabel[next] || next) : "-";
  return <span>{p} → {n}</span>;
}

export const ConfirmStatusOptions = [
  { label: "全部", value: "", key: "0" },
  { label: "待审核", value: "PENDING", key: "1" },
  { label: "已驳回", value: "REJECTED", key: "2" },
  { label: "取消中", value: "CANCEL", key: "4" },
  { label: "编辑中", value: "EDIT", key: "5" },
];

export function renderPlatformTooltip(record: any) {
  const safe = (v: any) => v || '-';
  const fmt = (v: any) => formatAmountZhCn(v || 0);
  const loanTypeMap: Record<string, string> = { MORTGAGE: '按揭贷款', CARD: '信用卡', BORROW: '借款' };
  const loanType = record.loanType || '';
  const typeName = loanTypeMap[loanType] || loanType;
  const colorMap: Record<string, string> = { MORTGAGE: '#1677ff', CARD: '#722ed1', BORROW: '#fa8c16' };
  const color = colorMap[loanType] || '#30332e';
  const row: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', padding: '3px 0', fontSize: 13 };

  let items: { label: string; value: string }[];
  if (loanType === 'MORTGAGE') {
    items = [
      { label: '贷款类型', value: typeName },
      { label: '贷款编号', value: safe(record.loanNo) },
      { label: '贷款金额', value: fmt(record.amount) },
      { label: '按揭期数', value: record.term ? `${record.term}期` : '-' },
      { label: '首次还款日', value: safe(record.firstPayDate) },
    ];
  } else if (loanType === 'CARD') {
    items = [
      { label: '贷款类型', value: typeName },
      { label: '贷款编号', value: safe(record.loanNo) },
      { label: '贷款金额', value: fmt(record.amount) },
      { label: '还款日', value: safe(record.dueDate) },
    ];
  } else {
    items = [
      { label: '贷款类型', value: typeName },
      { label: '借款编号', value: safe(record.loanNo) },
      { label: '借款金额', value: fmt(record.amount) },
      { label: '出款人', value: safe(record.borrowerName) },
      { label: '借款日期', value: safe(record.borrowDate) },
    ];
  }

  return (
    <div style={{ width: 300, padding: '4px 0' }}>
      <div style={{ padding: '6px 10px', borderRadius: 6, background: _tooltipCardBg, borderLeft: `3px solid ${color}` }}>
        {items.map(item => (
          <div key={item.label} style={row}>
            <span style={{ color: 'var(--semi-color-text-2)', fontWeight: 500 }}>{item.label}</span>
            <span style={{ fontWeight: 'bold', color: 'var(--semi-color-text-0)' }}>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

